export default __webpack_public_path__ + "img/rule_select-8850bc20.png";